
/* Requires a config file (sitting just outside the components folder) with the following values based on ENVs: 
    - app.service_name (a string)
    - logging.key (the api key for the logging service, secret found in Google Cloud)
    - logging.endpoint (the endpoint for the logging service, there is both staging and prod)
*/

import config from './config'

const loadTime = Date.now();
let currentUser = 'unavailable';
let lastError = { message: '', timestamp: 0 };

window.setLogUser = (email) => {
    currentUser = email;
};

// post to logging service on demand, use in the catch of try-catch blocks
window.logError = (err, context = 'general') => {
    console.error(context, err)
    if (!config.logging.endpoint) {
        if (config.env === 'production' || config.env === 'staging') {
            console.error("Missing logging endpoint URL!")
        }
        return;
    }

    const message = err.message || err;
    const now = Date.now();

    if (message === lastError.message && (now - lastError.timestamp) < 100) {
        return;
    }

    lastError = { message, timestamp: now };
    fetch(config.logging.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': config.logging.key },
        body: JSON.stringify({
            user: currentUser,
            message: `FRONTEND (${config.app.service_name}): ${err?.message || err}`,
            stack: err.stack || null,
            severity: 'ERROR',
            context: context,
            service: config.app.service_name,
            metadata: {
                url: window.location.href,
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                screenSize: `${window.innerWidth}x${window.innerHeight}`,
                timeSinceLoad: (Date.now() - loadTime) / 1000 + 's',
                isOnline: navigator.onLine
            },
            wholeError: err
        }),
        keepalive: true
    }).catch(e => { console.warn("Log failed to send", e) });
};

// catch standard JS errors (syntax, null pointers, etc.)
window.onerror = function (message, source, lineno, colno, error) {
    console.error('Uncaught Error: ' + error)
    if (!config.logging.endpoint) {
        if (config.env === 'production' || config.env === 'staging') {
            console.error("Missing logging endpoint URL!")
        }
        return;
    }
    const now = Date.now();

    if (message === lastError.message && (now - lastError.timestamp) < 100) {
        return;
    }

    lastError = { message, timestamp: now };
    fetch(config.logging.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': config.logging.key },
        body: JSON.stringify({
            user: currentUser,
            severity: 'ERROR',
            message: `FRONTEND (${config.app.service_name}): ${message}`,
            stack: error ? error.stack : null,
            service: config.app.service_name,
            metadata: {
                url: window.location.href,
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                screenSize: `${window.innerWidth}x${window.innerHeight}`,
                timeSinceLoad: (Date.now() - loadTime) / 1000 + 's',
                isOnline: navigator.onLine
            },
            wholeError: error
        })
    });
};

// catch unhandled promise rejections (catch failed async/await calls)
window.onunhandledrejection = function (event) {
    console.error('Unhandled Rejection: ' + event)
    if (!config.logging.endpoint) {
        if (config.env === 'production' || config.env === 'staging') {
            console.error("Missing logging endpoint URL!")
        }
        return;
    }
    const message = event.reason;
    const now = Date.now();

    if (message === lastError.message && (now - lastError.timestamp) < 100) {
        return;
    }

    lastError = { message, timestamp: now };

    fetch(config.logging.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-api-key': config.logging.key },
        body: JSON.stringify({
            user: currentUser,
            severity: 'ERROR',
            message: `FRONTEND (${config.app.service_name}): ${event.reason}`,
            service: config.app.service_name,
            metadata: {
                url: window.location.href,
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                screenSize: `${window.innerWidth}x${window.innerHeight}`,
                timeSinceLoad: (Date.now() - loadTime) / 1000 + 's',
                isOnline: navigator.onLine
            },
            wholeError: event
        })
    });
};